/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{isColorOrColorEmission as e}from"../ShaderOutput.js";import{VertexTextureCoordinates as r}from"../attributes/VertexTextureCoordinates.glsl.js";import{glsl as o}from"../../shaderModules/glsl.js";import{Texture2DDrawUniform as t}from"../../shaderModules/Texture2DDrawUniform.js";import{AlphaDiscardMode as s}from"../../../lib/basicInterfaces.js";function u(u,a){const d=a.hasColorTexture&&(e(a.output)||a.alphaDiscardMode!==s.Opaque);d&&(u.include(r,a),u.fragment.uniforms.add(new t("baseColorTexture",(e=>e.texture)))),u.fragment.code.add(o`
    vec4 readBaseColorTexture() {
      return ${d?"textureLookup(baseColorTexture, vuv0)":"vec4(1.0)"};
    }
  `)}export{u as ReadBaseColorTexture};
